import { SET_EXTENSIONS } from './index'

export function setExtensions (data) {
  return {
    type: SET_EXTENSIONS,
    payload: data
  }
}
